import { zRequiredDate, zRequiredString, zString } from '@/form/zod.utils';
import z from 'zod';

export const createCommercialAnalysisSchema = z.object({
  dateOfCreation: zRequiredDate,
  projectId: zRequiredString,
  sequencingTypeId: zString,
  allowPartialRun: z.boolean().optional(),
  forceRun: z.boolean().optional(),
});

export const updateCommercialAnalysisSchema =
  createCommercialAnalysisSchema.partial();
